import React, { useEffect, useState } from 'react';
import '../../styles/Announcments.css';
import { bullhorn } from '../../assets/index';
import 'boxicons/css/boxicons.min.css';
import {getAnnouncements} from '../../services/getAdminApi'


const Announcments = () => {
    const [isFocused, setIsFocused] = useState(false);
    const [announcements, setAnnouncments] = useState([])

    useEffect(()=>{
        getAnnouncements()
        .then((response)=>{
        
             setAnnouncments(response.data)
        })
    },[])
    
    const [openAnnouncementIndex, setOpenAnnouncementIndex] = useState(null);

    const toggleAnnouncement = (index) => {
        if (openAnnouncementIndex === index) {
            setOpenAnnouncementIndex(null);
        } else {
            setOpenAnnouncementIndex(index);
        }
    };

    return (
        <>
       
            <div className='announcment-upper-div'>
                <div className='annc-img-div'>
                    <img src={bullhorn} alt="Bullhorn" />
                </div>

                <div className='annc-search-div'>
                    <span className='ancc-span'>Announcements</span>
                    <div className={`search-box ${isFocused ? 'focused' : ''}`}>
                        <input
                            type="text"
                            placeholder="Search..."
                            className="search-input"
                            onFocus={() => setIsFocused(true)}
                            onBlur={() => setIsFocused(false)}
                        />
                        <button className="search-icon">
                            <i className='bx bx-search'></i>
                        </button>
                    </div>
                </div>
            </div>

        
            <div className="announcements">
                {announcements && announcements.length>0 ?
                
                announcements.map(({ date, title, description }, index) => (
                    <div
                        key={index}
                        className="ancc-announcement"
                        onClick={() => toggleAnnouncement(index)}
                    >
                        <div className="announcement-header">
                            <div className='ancc-date-line'>
                            <span className="ancc-date">{date===undefined ? '4 June 2024': date}</span>
                            <div className="vertical-line"></div>
                            </div>
                            
                            <div>
                            <span className="ancc-title">{title}</span>
                            <p style={{ marginTop: '0.6rem',color: '#403535'}}>{description.substring(0,150)}...</p>
                            </div>
                        </div>
                        {openAnnouncementIndex === index && <div className="announcement-content">{description}</div>}
                    </div>
                )) :
                "No Announcements Found"
            }
            </div>
          
        </>
    );
};

export default Announcments;
